import { Component, inject } from '@angular/core';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { AsyncPipe } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-colorcode-legend',
  imports: [AsyncPipe, ModalModule],
  templateUrl: './colorcode-legend.component.html',
  styleUrls: ['./colorcode-legend.component.scss'],
})
export class ColorcodeLegendComponent {
  readonly theme$ = inject(ThemeService).getTheme();
}
